import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { ISetAutopilotEnabledV1Request } from './set-autopilot-enabled-v1-request';
import type { ISetAutopilotEnabledV1Response } from './set-autopilot-enabled-v1-response';
import { setAutopilotEnabledV1ResponseSchema } from './set-autopilot-enabled-v1-response';

export async function setAutopilotEnabledV1Api(
  body: ISetAutopilotEnabledV1Request,
): Promise<IValidatedResponse<ISetAutopilotEnabledV1Response>> {
  return putRequest<ISetAutopilotEnabledV1Response>({
    path: '/sys/social/v1/autopilot/status',
    body,
    schema: setAutopilotEnabledV1ResponseSchema,
  });
}
